export enum askTypes {
  'confirm',
  'askForText',
  'askForNumber',
  'askForSelection',
}
